namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_catalog, {

		Public_icon: {
			align: {
				self: 'center',
			},
		},

		Menu_item: {
			position: 'relative',
		},

		Map_menu_links: {
			flex: {
				direction: 'column',
			},
		},

		Favorite_action: {
			position: 'absolute',
			top: '50%',
			right: 0,
			transform: 'translateY( -50% )',
			height: 'auto',
			background: {
				color: 'var(--mol_theme_back)' as any,
			},
			opacity: 0,
			pointerEvents: 'none',
			zIndex: 1,
		},

		Editor_mode_action: {
			position: 'absolute',
			top: '50%',
			right: '2rem',
			transform: 'translateY( -50% )',
			height: 'auto',
			background: {
				color: 'var(--mol_theme_back)' as any,
			},
			opacity: 0,
			pointerEvents: 'none',
			zIndex: 1,
		},

		Favorite: {
			width: '2rem',
			height: '2rem',
			background: {
				color: 'var(--mol_theme_card)' as any,
			},
		},

		Editor_mode: {
			width: '2rem',
			height: '2rem',
			background: {
				color: 'var(--mol_theme_card)' as any,
			},
		},

		Menu_title: {
			flex: {
				grow: 0,
			},
		},

		List_head: {
			flex: {
				grow: 1,
			},
		},

		Add_map_anchor: {
			cursor: 'default',
		},

	} )

}
